import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Playroom } from 'src/app/admin/models/playroom.model';
import { PlayroomService } from 'src/app/admin/services/playroom.service';

@Component({
  selector: 'app-delete-playroom-modal',
  templateUrl: './delete-playroom-modal.component.html',
  styleUrls: ['./delete-playroom-modal.component.scss'],
})
export class DeletePlayroomModalComponent implements OnInit {

  room: Playroom;

  constructor(private modalController: ModalController, private roomService: PlayroomService) { }

  ngOnInit() {}


  removeRoom() {
    this.roomService.deletePlayroom(this.room.id).subscribe(res => {
      this.roomService.getAllPlayrooms();
      this.dismissModal();
    },(err) => {
      console.error(err);
    })
  }

  dismissModal() {
    this.modalController.dismiss();
  }

}
